module.exports = __webpack_public_path__ + "lora-cloud.9d8f04730d97c3bff7cef9345d4acf11.png";